import React from 'react';
import { LlmChunkItem } from '../../../types';
import { Event } from '../Event/event';
import { EventGroup } from '../EventGroup/eventgroup';
import { FormRecap } from '../FormRecap/FormRecap';
import { FormRecapError } from '../FormRecapError/FormRecapError';
import { FormRecapSuccess } from '../FormRecapSuccess/FormRecapSuccess';
import { FormRequest } from '../FormRequest/FormRequest';
import { Poi } from '../Poi/poi';
import { PoiGroup } from '../PoiGroup/poigroup';
import { Text } from '../Text/text';
import { TripAdvisorGroup } from '../Tripadvisor/tripadvisor';

export type ChunkProps = {
  item: LlmChunkItem;
  index: number;
  total: number;
};

export const Chunk: React.FC<ChunkProps> = ({
  item,
  index,
  total,
}: ChunkProps) => {
  switch (item.type) {
    case 'string': {
      return item.content.length > 0 && (
        <Text body={item.content} disclaimer={index === 0} />
      );
    }
    case 'event':
    case 'eventItem': {
      return (
        <Event {...item} />
      );
    }
    case 'eventGroup':
      return (
        <EventGroup {...item} />
      );
    case 'poi':
    case 'poiItem': {
      return (
        <Poi {...item} />
      );
    }
    case 'poiGroup':
      return (
        <PoiGroup {...item} />
      );
    case 'tripadvisorGroup':
      return (
        <TripAdvisorGroup {...item} />
      );
    case 'formRequest':
      return (
        <FormRequest last={index === total - 1} />
      );
    case 'formRecap':
      return (
        <FormRecap />
      );
    case 'formRecapSuccess':
      return (
        <FormRecapSuccess />
      );
    case 'formRecapError':
      return (
        <FormRecapError />
      );
    case 'image':
      return (
        <img src={item.src as string} />
      );
    default:
      return (
        <code>{JSON.stringify(item)}</code>
      );
  }
};
